<template>
  <div>
    <h2>商品カセット</h2>
    <div class="product-input-form" v-if="isEditing">
      <div class="container">
        <div class="form-group container__item">
          <label>
            <p>商品名</p>
            <input type="text" v-model="product.name" />
          </label>
          <label>
            <p>説明文</p>
            <input type="text" v-model="product.description" />
          </label>
          <label>
            <p>価格(optional)</p>
            <input type="text" v-model="product.price" />
          </label>
          <label>
            <p>スコア</p>
            <input type="number" min="1" max="5" v-model="product.score" />
          </label>

          <label>
            <p>関連リンク</p>
          </label>
          <button v-if="product.relatedLinks.length < 5" @click="addLink">
            追加
          </button>
          <div>
            <ul>
              <li v-for="(link, index) in product.relatedLinks" :key="index">
                <p>url: <input type="text" v-model="link.url" /></p>
                <p>title: <input type="text" v-model="link.title" /></p>
                <button @click="removeLink(index)">削除</button>
              </li>
            </ul>
          </div>
        </div>
        <div class="form-group container__item">
          <ul class="editing-images">
            <li
              v-for="(img, i) in product.images"
              :key="i"
              class="editing-images__item"
            >
              <img :src="img.url" alt="" />
              <button @click="removeImage(i)" class="editing-images__remove">
                <i class="fa fa-close"></i>
              </button>
            </li>
          </ul>
          <image-uploader @add="addImage" />
        </div>
      </div>
      <div class="form-group__footer">
        <a class="btn-green" @click="onEndEdit()">追加</a>
        <a class="btn-green" @click="onDeleteInput()">削除</a>
      </div>
    </div>
    <div class="product-input-preview input-preview" v-else>
      <div class="product">
        <div class="product__head">
          <time>{{ formattedDate }}</time>
          <div class="product__score">
            <p class="product__score-star">
              {{ stars }}
            </p>
            <p>({{ product.score }})</p>
          </div>
        </div>

        <p class="product__text">商品名: {{ product.name }}</p>
        <p class="product__text">説明: {{ product.description }}</p>
        <p v-if="product.price" class="product__text">
          価格: {{ product.price }}
        </p>
        <div class="product__links">
          <p>関連リンク</p>
          <ul v-if="product.relatedLinks.length > 0">
            <li
              v-for="(link, i) in product.relatedLinks"
              :key="i"
              class="product__link-item"
            >
              <p>title: {{ link.title }}</p>
              <p>url: {{ link.url }}</p>
            </li>
          </ul>
          <p v-else class="product__link-empty">なし</p>
        </div>
        <div class="product__links">
          <p>画像</p>
          <ul v-if="product.images.length > 0" class="product__images">
            <li
              v-for="(img, i) in product.images"
              :key="i"
              class="product__image"
            >
              <img :src="img.url" :alt="img.alt" />
            </li>
          </ul>
          <p v-else class="product__link-empty">なし</p>
        </div>
      </div>
      <footer-menu
        :onDeleteInput="onDeleteInput"
        :onBeginEdit="onBeginEdit"
        :onPullUp="onPullUp"
        :onPullDown="onPullDown"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import FooterMenu from '../input-footer-menu.vue';
import ImageUploader from '../StoreEditor/ImageUploader.vue';

const SCORE_MAX = 5;

export default {
  name: 'ProductEditor',
  components: {
    FooterMenu,
    ImageUploader,
  },
  props: {
    value: Object,
    index: Number,
    id: String,
  },
  data() {
    return {
      isEditing: false,
      isUploading: false,
      product: {
        name: this.value.name,
        description: this.value.description,
        price: this.value.price,
        score: this.value.score,
        images: this.value.images,
        relatedLinks: this.value.related_links,
        created_at: this.value.created_at
          ? new Date(this.value.created_at)
          : new Date(),
      },
    };
  },
  computed: {
    stars() {
      return '★'.repeat(this.product.score).padEnd(SCORE_MAX, '☆');
    },
    formattedDate() {
      const d = this.product.created_at;
      return `${d.getFullYear()}/${
        d.getMonth() + 1
      }/${d.getDate()} ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`;
    },
    bodyJSON() {
      const value = {
        name: this.product.name,
        description: this.product.description,
        price: this.product.price,
        score: this.product.score,
        images: this.product.images,
        related_links: this.product.relatedLinks,
      };

      if (!value.price) {
        delete value.price;
      }

      return {
        value,
        action: 'general-product',
        id: this.id,
      };
    },
    editorOptions() {
      return {
        modules: {
          table: true,
          toolbar,
        },
      };
    },
  },
  methods: {
    onBeginEdit() {
      this.isEditing = true;
    },
    onEndEdit() {
      this.product.score = Math.min(Math.max(this.product.score, 0), SCORE_MAX);
      this.product.relatedLinks = this.product.relatedLinks.filter(
        ({ title, url }) => title || url
      );

      if (this.product.name.length === 0) {
        alert('商品名を入力してください');
        return false;
      }
      if (this.product.description.length === 0) {
        alert('説明を入力してください');
        return false;
      }
      if (this.product.relatedLinks.some((link) => link.title.length === 0)) {
        alert('関連リンクのタイトルを入力してください');
        return false;
      }
      if (this.product.relatedLinks.some((link) => link.url.length === 0)) {
        alert('関連リンクのURLを入力してください');
        return false;
      }
      this.isEditing = false;
    },
    onDeleteInput() {
      bus.$emit('delete-input', this.index);
    },
    onPullUp() {
      bus.$emit('pull-up-item', this.index);
    },
    onPullDown() {
      bus.$emit('pull-down-item', this.index);
    },
    addLink() {
      this.product.relatedLinks = [
        ...this.product.relatedLinks,
        {
          url: '',
          title: '',
        },
      ];
    },
    removeLink(index) {
      this.product.relatedLinks = this.product.relatedLinks.filter(
        (_, i) => i !== index
      );
    },
    addImage(img) {
      this.product.images = [...this.product.images, img];
    },
    removeImage(index) {
      this.product.images = this.product.images.filter((_, i) => i !== index);
    },
  },
};
</script>

<style lang="scss" scoped>
.product-input-form {
  background-color: #eee;
  position: relative;
  padding: 15px 15px 1px;
  margin: 0 0 10px;

  h2 {
    font-size: 14px;
    margin: 0 0 10px;
  }
}

.container {
  display: flex;
  flex-direction: row;
  gap: 12px;

  &__item {
    flex-basis: 50%;
  }
}

.form-group {
  &__item {
    &:nth-child(n + 2) {
      margin-top: 8px;
    }
  }

  &__footer {
    &:nth-child(n + 2) {
      margin-top: 12px;
    }
  }
}

.ql-editor {
  font-size: 15px;
}

.product {
  border: 1px solid lightgrey;
  border-radius: 4px;
  padding: 12px;
  font-size: 14px;

  &__head {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__score {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &__score-star {
    color: #fab704;
  }

  &__text {
    margin-top: 12px;
  }

  &__links {
    margin-top: 12px;
  }

  &__link-item {
    margin-top: 8px;
    margin-left: 12px;

    &:nth-child(n + 2) {
      border-top: 1px dotted gray;
      padding-top: 8px;
    }
  }

  &__link-empty {
    margin-top: 8px;
    margin-left: 12px;
  }
  &__images {
    display: flex;
    height: 100px;
    gap: 2px;
  }
  &__image {
    width: 120px;
    height: 100px;
    margin-top: 2px;
    > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.editing-images {
  display: flex;

  &__item {
    position: relative;
    max-width: 100px;
    height: 100px;
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__remove {
    position: absolute;
    right: 4px;
    top: 4px;
    width: 15px;
    height: 15px;
    display: flex;
    padding-bottom: 2px;
    justify-content: center;
    align-items: center;
    border: 1px solid black;
    background-color: white;
    font-size: 12px;
    border-radius: 50%;
    cursor: pointer;
  }
}
</style>
